// Theme first, so the page never flashes the wrong mode.
import './lib/theme'
import '@fontsource/cinzel/600.css'
import '@fontsource/cinzel/700.css'
import '@fontsource/alegreya-sans/400.css'
import '@fontsource/alegreya-sans/400-italic.css'
import '@fontsource/alegreya-sans/500.css'
import '@fontsource/alegreya-sans/700.css'
import './styles/tokens.css'
import './styles/base.css'
import './styles/app.css'
import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router/dom'
import { createRouter } from './App'
import { SessionProvider } from './lib/session'

const root = document.getElementById('root')!
const app = (
  <StrictMode>
    <SessionProvider>
      <RouterProvider router={createRouter()} />
    </SessionProvider>
  </StrictMode>
)
// Prerendered pages (scripts/prerender.tsx) already hold the app's first render: take it over in
// place, so nothing redraws. Every other path starts from an empty #root.
if (root.hasChildNodes()) hydrateRoot(root, app)
else createRoot(root).render(app)
